import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import DatosProveedor from "../../components/common/DatosProveedor";
import Modal from "../../components/common/Modal";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorContacto_Ex,initDataProveedorContactoMedContacto_Ex,initDataProveedorContacto_Val,initDataProveedorContactoMedContacto_Val, initDataProveedorDB } from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Validate from "../../utils/Validate";

const ProveedoresFinalizar = ({dataT}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });

  const [data, setData] = useState(dataT);

  return (
           <div className="proveedores_content">  
              <h4 className="title-05 margin-bottom-16 margin-top-16">
                <b>Registro <span class="title-red">Finalizado</span></b>
              </h4>                
              <div className="d-justify-space-between d-flex-column-m w100">
                <div className="documents_criteria_datos">
                Gracias por completar la información solicitada, para seguir con la evaluación, firmar el archivo enviado a su correo {dataT && dataT.correoNotificacion} y enviarlo a tu contacto de RIMAC.
                </div>
              </div>       
              
            </div>
  );
};


export default ProveedoresFinalizar;
